import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer"
import bannerImage from "../../Images/Banner/library-banner.webp"
import Vision from "../../Images/commonimg/vision-library.webp"
import Mission from "../../Images/commonimg/mission-library.webp"
import libr1 from "../../Images/campus/lib-1.webp";

const Elibrary = () => {

    const libraryFacilities = [
        {
            iconClass: "ti ti-book-2", // Represents reading/learning
            title: "Understanding E-Resources",
            description: "Explore their meaning and role in digital learning"
        },
        {
            iconClass: "ti ti-devices", // Multiple formats like audio, video, documents
            title: "Types of Electronic Resources",
            description: "Classify key formats used in modern research"
        },
        {
            iconClass: "ti ti-book-download", // Represents digital books/journals
            title: "E-Books and E-Journals Defined",
            description: "Know the digital versions of books and journals"
        },
        {
            iconClass: "ti ti-database-search", // Represents a searchable database
            title: "What Are Electronic Databases?",
            description: "Understand organized online collections of information"
        },
        {
            iconClass: "ti ti-notes", // More universally supported and relevant
            title: "Bibliographic vs Full Text Databases",
            description: "Differentiate between data references and complete content"
        }
    ];

    return (
        <React.Fragment>
            <title>E-Library | Digital Resources & Research Access</title>
            <meta
                name="description"
                content="Explore our E-Library access for students — journals, e-books, databases available anytime. Enhance your learning — access resources now!"
            />
            <Topnav />
            <section className="section-hero-banner ptb-50" style={{
                backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
            }}>
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Campus E-Learning Hub</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>Home</a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    e-Library
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50">
                <div className="container-xxl">
                    <div className="vc-paragraphs mx-auto">
                        <div className="text-center mb-5">
                            <h2 className="section-title modern-title text-blue mt-3">A dynamic hub for research & innovation</h2>
                        </div>
                        <p>
                            The advent of Internet has dramatically changed the way people and institutions function. It
                            has led to tremendous change in the way libraries function and offer services
                            to their users. At present, the libraries actively procure, organize, display
                            and issue e-forms of books, journals, newspapers, theses and dissertations.
                            This is also due to change in information seeking
                        </p>
                        <p>
                            Behavior of users.The new generation of users prefers online resources as they want all
                            information at the click of mouse. The e- resources have certain inherent
                            characteristic features which offer convenience to the users. This lesson
                            discusses the concept and importance of e-resources. It deals with different
                            types of e-resources, their advantages and disadvantages.
                        </p>
                        {/* <p className="m-0">The Library of college has been well equipped with the latest information technologies and web based information Resources,<strong> e-books and e-Journals search, OPAC, Web OPAC and Internet browsing</strong> as it is well connected through LAN/ BSNL 100mbps Fiber Optic Internet Connection. The Library maintains around more than one lake collections of books, reference book, thesis, and monograph, back volumes of journals, audio-visuals and e-resources.</p> */}
                    </div>
                </div>
            </section>


            <section className="sports-facilities-section pb-100 sports-info-section ptb-50">
                <div className="container-xxl">
                    <h2 className="section-title modern-title text-center text-white">Empowering Learning Through Premier Library Resources</h2>
                    {/* <h6 className="modern-subtitle text-center text-white">The Central Library offers a rich collection of physical and digital resources, study spaces, and efficient services through the Koha system to support academic and research needs.
                    </h6> */}
                    <div className="row">
                        {libraryFacilities.map((facility, index) => (
                            <div className="col-md-4 col-sm-6 col-12 mb-3 d-flex">
                                <div key={index} className="sports-facility-card m-auto h-100 w-100">
                                    <div className="facility-icon">
                                        <i className={`${facility.iconClass} facility-icon-style`}></i>
                                    </div>
                                    <h3 className="facility-title">{facility.title}</h3>
                                    <p className="facility-description">{facility.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="hostel-discipline-section ptb-50">
                <div className="container-xxl">
                    <Row className="align-items-center">
                        <div className="col-md-6 col-12 mb-3">
                            <div className="library-image-container">
                                <img
                                    src={Vision}
                                    className="library-image rounded-3"
                                    alt="Library Vision"
                                    loading="lazy"
                                />
                                <div className="image-frame"></div>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="discipline-content">
                                <h2 className="modern-title section-title-start text-blue">e-Library Advantages</h2>
                                <p>
                                    Electronic resources have transformed how users access and interact with information. They offer unmatched convenience, especially for users in remote areas, and support simultaneous access, flexible searching, and multimedia content. Libraries benefit from usage tracking and space-saving, making e-resources a practical and powerful alternative to print materials. Below are the key advantages of e-resources:
                                </p>
                                <ul className="list-unstyled">
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        E-resources may be accessed over the Internet. The users need not physically visit the library. This is very useful for the users who reside in remote and far flung areas. The users may download the articles and save them in their PCs.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        The same resource, i.e., article or journal may be accessed by many users at the same time.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        E-resources may be accessed from anywhere, anytime as per the convenience of the users.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        The users may search a large number of resources in one go through a single search interface.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        E-Resources also provide usage statistics which help the library staff in finding out the usage of the product.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        Articles/issues of journals appear online before their print version is available.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        Hypertext format and links of e-resources lead users to related content and articles.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        Electronic resources have audio, video and animation content which is not present in print format.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        The subscription of e-resources helps libraries in saving space.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="hostel-discipline-section ptb-50 flex-wrap-reverse">
                <div className="container-xxl">
                    <Row className="align-items-center flex-wrap-reverse">
                        <div className="col-md-6 col-12">
                            <div className="discipline-content">
                                <h2 className="modern-title section-title-start text-blue">e-Library Disadvantages</h2>
                                <p>
                                    While e-resources offer many benefits, they also come with certain limitations. Dependence on internet access, subscription-based access, and the strain of on-screen reading can hinder their usability. These factors may affect the overall accessibility and comfort of using electronic resources. Below are the main disadvantages of e-resources:
                                </p>
                                <ul className="list-unstyled">
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        The readers need to have access to Internet in order to read electronic resources.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        If a library cancels or stops subscription to an e-journal, it is not certain that the library will get access to back issues of that journal. Whereas, library having printed material certainly has back issues of that journal in its possession. In case of e-books too, if a library stops subscription to eBooks, it is denied access to the e-book. Whereas the physical copy once bought always remains in the possession of the library.
                                    </li>
                                    <li className="mb-1">
                                        <i className="ti ti-circle-check text-blue me-2"></i>
                                        Use of e-resources entails reading on screen which is tedious and harmful too.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-12 mb-3">
                            <div className="library-image-container">
                                <img
                                    src={Vision}
                                    className="library-image rounded-3"
                                    alt="Library Vision"
                                    loading="lazy"
                                />
                                <div className="image-frame"></div>
                            </div>
                        </div>
                    </Row>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    );
};

export default Elibrary;